import { useState, useEffect } from 'react';
import hasChannelWithoutFullPostingPermissions from '../../utils/hasChannelWithoutFullPostingPermissions';

function useChannelPermissions({ channelsSelected, listOfChannels }) {
  const [isViewOnly, setViewOnly] = useState(false);

  useEffect(() => {
    setViewOnly(
      hasChannelWithoutFullPostingPermissions({
        channelsSelected,
        listOfChannels,
      })
    );
  }, [channelsSelected, listOfChannels]);

  return { isViewOnly };
}

export default useChannelPermissions;
